// Updates badge counters for notification and message dropdowns.
export function updateBadgeFor(drop: Element | null) {
  if (!drop) return;

  const button = drop.querySelector<HTMLElement>('.dropdown-toggle.icon-btn');
  const menu = drop.querySelector<HTMLElement>('.dropdown-menu');
  if (!button || !menu) return;

  let count = 0;
  if (menu.classList.contains('menu-notifications')) {
    count = menu.querySelectorAll('.alert-item.unread').length;
  } else if (menu.classList.contains('menu-messages')) {
    count = menu.querySelectorAll('.msg-item.unread').length;
  }

  if (count > 0) button.setAttribute('data-count', String(count));
  else button.removeAttribute('data-count');
}

// Convenience: update badges for every dropdown in the root.
export function updateAllBadges(root: ParentNode) {
  root.querySelectorAll('.dropdown').forEach((drop) => updateBadgeFor(drop as Element));
}
